// extracted by mini-css-extract-plugin
export default {"verticalLine":"divider-component_verticalLine__Tlp9b","dividerCenter":"divider-component_dividerCenter__EgRtt"};